var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intro"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('introduction.title')))]),_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.$t('introduction.subtitle')))]),_c('intro-slides',{attrs:{"activeCard":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }